// @flow
import React, { PureComponent, Fragment } from 'react';
import type { BlocContent } from 'types/NewsletterBloc';
import ContentBloc from 'components/newsletter/blocs/ContentBloc';
import Sidebar from 'components/sidebar/Sidebar';
import { getFirstBlocText } from 'utils/blocUtils';
import BackgroundImage from 'components/fragments/BackgroundImage';
import SimpleCarousel from 'components/fragments/SimpleCarousel/SimpleCarousel';

export type StateProps = {
  medias: {
    content: BlocContent[],
    media: any[]
  }
};

type Props = StateProps;

type ComponentState = {
  isOpen: boolean,
  indexOpen: number,
  caroussel: boolean,
  indexImages: number
};

class CompetitionMedia extends PureComponent<Props, ComponentState> {
  state: ComponentState = {
    isOpen: false,
    indexOpen: 0,
    caroussel: false,
    indexImages: 0
  }

  renderContent = () => {
    const { medias } = this.props;

    if (!medias) {
      return null;
    }
    return medias.content.map<any>((blocFigure, index) => <ContentBloc key={index} {...blocFigure} />);
  }

  handleClick = (object_id: number) => {
    return () => {
      this.setState({
        isOpen: true,
        indexOpen: object_id
      });
    };
  }

  backToList = () => {
    this.setState({
      isOpen: false
    });
  }

  renderCardGallery = () => {
    const { medias } = this.props;

    if (!medias.media) {
      return null;
    }

    return medias.media.map<any>((gallery, index) => {
      const imageNumber = gallery.content.data.filter(gallery => gallery.tagName === "gallery");
      return(
        <div className="col col-md-6 mb-4" key={index}>
          <a
            className='box card card--content card--date card--day'
            onClick={this.handleClick(gallery.object_id)}>
            <BackgroundImage
              className="card__thumbnail img-blue"
              illustration={"/img/trash/card.jpg"}
              />
            <div className="card__label label label--transparent">{imageNumber[0] && imageNumber[0].children.length}</div>
            <div className="card__body">
              <h3 className="card__title">{gallery.title}</h3>
              <p className="card__desc"></p>
            </div>
            <div className="card__footer">
              <span className="link-chevron">
                <i className="icon icon-chevron-right" />
              </span>
            </div>
          </a>
        </div>
      );
    });
  }

  renderImages = (images: BlocContent[]): any => {
    const { caroussel, indexImages } = this.state;
    if (!images) {
      return null;
    }
    const displayedImages = images.filter(gallery => gallery.tagName === "gallery");
    if (displayedImages.length === 0 || !displayedImages[0].children) {
      return null;
    }
    // TODO : add algo to right and left
    return (
      <div className="mosaic-images">
        { caroussel &&
          <SimpleCarousel
            onCloseRequest={this.closeCaroussel}
            data={displayedImages[0].children}
            initialIndex={indexImages} />
        }
        <div className="mosaic-images__left">
          {displayedImages[0].children && displayedImages[0].children.map<any>((image, index) => {
            if (displayedImages[0].children && index > displayedImages[0].children.length / 2) {
              return null;
            }
            if (!image.featured_image) {
              return null;
            }
            return (
              <BackgroundImage
                key={index}
                illustration={image.featured_image.src}
                srcset={image.featured_image.size}
                onClick={this.openCaroussel(index)}
                />
            );
          })}
        </div>
        <div className="mosaic-images__right">
          {displayedImages[0].children && displayedImages[0].children.map<any>((image, index) => {
            if (displayedImages[0].children && index < displayedImages[0].children.length / 2) {
              return null;
            }
            if (!image.featured_image) {
              return null;
            }
            return (
              <BackgroundImage
                key={index}
                illustration={image.featured_image.src}
                srcset={image.featured_image.size}
                onClick={this.openCaroussel(index)}
                />
            );
          })}
        </div>
      </div>
    );
  }

  renderDetailMedia = () => {
    const { medias } = this.props;
    const { indexOpen } = this.state;

    if (!medias.media) {
      return null;
    }

    const displayedGallery = medias.media.filter(gallery => gallery.object_id === indexOpen);

    if (displayedGallery.length > 0) {
      return (
        <Fragment>
          <div className="col col-lg-8on9 mt-5">
            <a onClick={this.backToList} className="link-chevron link-chevron--left" data-label="">
              <span>Retour aux albums</span>
              <i className="icon icon-chevron-left"></i>
            </a>
          </div>
          <div className="col col-lg-8on9 mt-5">
            <h3 className="mb-1">{displayedGallery[0].title}</h3>
            <p className="ft-secondary mb-5">
              {getFirstBlocText(displayedGallery[0].content.data)}
            </p>
            {this.renderImages(displayedGallery[0].content.data)}
          </div>
        </Fragment>
      );
    }

    return null;
  }

  openCaroussel = (index: number) => () => {
    this.setState({
      caroussel: true,
      indexImages: index
    });
  }

  closeCaroussel = () => {
    this.setState({
      caroussel: false
    });
  }

  render() {
    const { isOpen } = this.state;

    if (isOpen) {
      return (
        <div className="container">
          <div className="row">
            <div className="col col-md-8 col-lg-9 bg-overflow">
              <section>
                <div className="row">
                  {this.renderDetailMedia()}
                </div>
              </section>
            </div>
            <Sidebar />
          </div>
        </div>
      );
    }

    return (
      <div className="container">
        <div className="row">
          <div className="col col-md-8 col-lg-9 bg-overflow">
            <section>
              <div className="row">
                <div className="col col-lg-8on9 page">
                  {this.renderContent()}
                  {this.renderCardGallery()}
                </div>
              </div>
            </section>
          </div>
          <Sidebar />
        </div>
      </div>
    );
  }
}

export default CompetitionMedia;
